import CryptoJS from "crypto-js";


export const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  export const baseUrl = "https://ubanking.suntrustng.com"


  const k = "TestEncryptionWa"

  const kk = "Watetsenpcryniot"

  // export const encR = (data) => {
  //   const key = CryptoJS.enc.Utf8.parse(k);
   
  //   const encrypted = CryptoJS.AES.encrypt(data, key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7,
  //   });
   
  //   return encrypted.toString();
  // };

  // export const e = (data) => {
  //   const key = CryptoJS.enc.Utf8.parse(kk);
   
  //   const encrypted = CryptoJS.AES.encrypt(data, key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7,
  //   });
   
  //   return encrypted.toString();
  // };

  // export const decR = (data) => {
  //   const ciphertext = data;
   
  //   const key = CryptoJS.enc.Utf8.parse(k);
   
  //   const decryptedBytes = CryptoJS.AES.decrypt(ciphertext, key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7,
  //   });
   
  //   return CryptoJS.enc.Utf8.stringify(decryptedBytes);
  // };

  // export const d = (data) => {
  //   const ciphertext = data;
   
  //   const key = CryptoJS.enc.Utf8.parse(kk);
   
  //   const decryptedBytes = CryptoJS.AES.decrypt(ciphertext, key, {
  //     mode: CryptoJS.mode.ECB,
  //     padding: CryptoJS.pad.Pkcs7,
  //   });
   
  //   return CryptoJS.enc.Utf8.stringify(decryptedBytes);
  // };